// Actions
export const DUTY_PHONE_FETCH  = '[DutyPhone] Fetch'

// Mutations
export const DUTY_PHONE_META   = '[DutyPhone] meta'
export const DUTY_PHONE_OBTAIN = '[DutyPhone] obtain'
export const DUTY_PHONE_CLEAR  = '[DutyPhone] clear'
export const DUTY_PHONE_SET_LOADING = '[DutyPhone] set loading'
